// extracted by mini-css-extract-plugin
export var category = "_jq-9";
export var categoryHeader = "_jq-e";
export var container = "_jq-0";
export var group = "_jq-a";
export var groupItems = "_jq-f";
export var groupSeparator = "_jq-j";
export var loading = "_jq-1";
export var noResults = "_jq-3";
export var placeholder = "_jq-2";
export var resultContent = "_jq-5";
export var resultIcon = "_jq-c";
export var resultItem = "_jq-g";
export var resultMeta = "_jq-8";
export var resultSubtitle = "_jq-7";
export var resultSuffix = "_jq-i";
export var resultTitle = "_jq-6";
export var resultsList = "_jq-4";
export var searchGroup = "_jq-d";
export var selected = "_jq-h";
export var subgroup = "_jq-b";